import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EventManagerService {
  lockAddCuttingPanel = false;
  addCuttingPanelEmitter$: Subscriber<void>;
  addCuttingPanel$: Observable<void> = new Observable<void>(e => (this.addCuttingPanelEmitter$ = e)).pipe(
    filter(() => !this.lockAddCuttingPanel)
  );

  constructor() {}
}
